export default {
    menu: {
        edit: 'edit',
        delete: 'delete'
    },
    delete: {
        title: 'Delete company-macro-trend {title}?',
        content: '<p>The company-macro-trend will be deleted for all participants.</p><p>Note: This action cannot be undone.</p>',
        confirm: 'Yes, delete now'
    }
}
